<template>
<div>
<div class="form-row">
    <div class="form-group col-md-8">
      <label for="CLIENTE">CLIENTE</label>
      
      <h4 style="color:#000099;font-size:25px"><strong>{{customer}}</strong></h4>   
      
    </div>
    <div class="form-group col-md-4">
      <label for="SALDO">SALDO</label>
      <h4><span class=""></span>  <span class="" v-bind:style="{ color : balance < 0 ?  'red' : '#009933',fontSize:'30px'}"><strong> {{fmtCurrency(balance)}}</strong>
        <span class="ml-2"><strong>€</strong></span>
        </span></h4>
      
      
    </div>
  </div>

<!--
<div class="row">
    <div class="col">
        <h4>CLIENTE <span style="color:#660099"><strong>{{customer}}</strong></span></h4>     
    </div>
    
    <div class="col">
        <h4>SALDO <span class="ml-3">:</span>  <span class="ml-3" v-bind:style="{ color : balance < 0 ?  'red' : '#009933',fontSize:'25px'}"><strong> {{fmtCurrency(balance)}}</strong>
        <span class="ml-2"><strong>€</strong></span>
        </span></h4>
    </div>
    
</div>
-->

</div>

</template>

<script>

import axios              from "axios"
import api                from '@/api'

export default {
props : ['customerId'],  
components: {
  },
  data () {
    return {
                 
        customer  : '',
        balance   : 0,
        
    }
  },
  directives: 
    {

      
    },
  computed: 
  {
     
  },
  mounted() 
  {
    
  },  
  created()
  {

   
   this.getData()
    
  },
  methods: 

  {
       
    async getData()
    {

      var sp    = {'sp':'spCustomerBalance'}
      
      var data  = {'customerId' : this.customerId}
      var json  = Object.assign(data, sp);
      
      await api.post(json).then(res => {
          if(res.status==200)
            {
              this.customer = res.data.recordsets[0][0].last_name + ' ' + res.data.recordsets[0][0].first_name 
              this.balance  = res.data.recordsets[0][0].balance         
            }
            else if(res.status==500)
            {
              console.log(res.data)
            

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
         
        });




       
      
    },
    
    fmtCurrency(value)
    { 
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
    },
 
    

  }
}
</script>
<style scoped>

h4,span,label {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

</style>